// extracted by mini-css-extract-plugin
export var container = "_dj-0";
export var popoverContent = "_dj-1";
export var tosLink = "_dj-2";